import React from "react";
import { useEffect } from "react";
import { WebRTCPlayer } from "@eyevinn/webrtc-player";
import { useParams } from "react-router-dom";

export default function Viewer() {
  const params = useParams();
  const streamCode = params.streamCode;

  useEffect(() => {
    (async () => {
      const video = document.querySelector("video")!;
      const player = new WebRTCPlayer({
        video: video,
        type: "whep",
        mediaConstraints: { videoOnly: true },
        statsTypeFilter: "^candidate-*|^inbound-rtp",
      });
      await player.load(
        new URL(`https://stream.fliteworks.com:8889/${streamCode}/whep`),
      );

      player.on("no-media", () => {
        console.log("media timeout occurred");
      });
      player.on("media-recovered", () => {
        console.log("media recovered");
      });

      // Subscribe for RTC stats: `stats:${RTCStatsType}`
      player.on("stats:inbound-rtp", (report) => {
        if (report.kind === "video") {
          console.log(report);
        }
      });
    })();
  }, []);

  return (
    <div className={"center"}>
      <div
        className={"viewer"}
        style={{ display: "flex", flexDirection: "column", paddingTop: 48 }}
      >
        <div className={"video"} style={{ flex: 1 }}>
          <video
            autoPlay
            muted
            playsInline
            controls
            style={{
              backgroundColor: "black",
              width: "80%",
              maxHeight: "80vh",
            }}
          ></video>
        </div>
        <div className={"logo"}>
          <img
            style={{ width: "10vw", padding: 24 }}
            src={"/assets/fliteworks_dark.svg"}
          />
        </div>
      </div>
    </div>
  );
}
